export const DESKTOP_SCALE = 800;
export const MOBILE_SCALE = 350;

export function getScrollScale() {
    return window.innerWidth >= 768 ? DESKTOP_SCALE : MOBILE_SCALE;
}
